import React, {useState, useEffect} from 'react';
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { onAuthStateChanged } from "firebase/auth";
import { projectAuth } from '../firebase/config';
import('bootstrap/dist/css/bootstrap.min.css');

const SharedLayout = () => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(projectAuth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <div className={`wrapper ${!user ? 'notAdmin' : 'isAdmin'}`}>
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    );
};

export default SharedLayout;
